const authorizedUserAttributes = ['fullName', 'email', 'dob', 'pan', 'aadhaar', 'mobile']
const authorizedUserDocuments = ['panDocument', 'aadhaarDocument']

const individual = {
  required: [...authorizedUserAttributes, ...authorizedUserDocuments, 'hasGSTN', 'termsAndConditions'],
  requiredWithGstn: ['gstn', 'address', 'location', 'pincode', 'gstnDocument'],
  optional: ['referralCode', 'aadhaarPassword', 'optinCommunication'],
}

const nri = {
  required: [
    'fullName',
    'email',
    'dob',
    'pan',
    'countryCode',
    'mobile',

    'panDocument',
    'phoneBillDocument',
    'nroDocument',

    'hasGSTN',
    'termsAndConditions',
  ],
  requiredWithGstn: ['gstn', 'address', 'location', 'pincode', 'gstnDocument'],
  optional: ['referralCode', 'aadhaarPassword', 'optinCommunication'],
}

const huf = {
  // Required attributes without gstn and req attributes with gstn
  required: [
    'entityName',
    'dof',
    'entityPan',
    ...authorizedUserAttributes,

    'entityPanDocument',
    ...authorizedUserDocuments,

    'hasGSTN',
    'termsAndConditions',
  ],
  requiredWithGstn: ['gstn', 'address', 'location', 'pincode', 'gstnDocument'],
  optional: ['referralCode', 'aadhaarPassword', 'optinCommunication'],
}

const llp = {
  required: [
    'entityName',
    'dof',
    'entityPan',
    ...authorizedUserAttributes,

    'partnershipDocument',
    'registrationDocument',
    'entityPanDocument',
    'resolutionDocument',
    ...authorizedUserDocuments,

    'hasGSTN',
    'termsAndConditions',
  ],
  requiredWithGstn: ['gstn', 'address', 'location', 'pincode', 'gstnDocument'],
  optional: ['referralCode', 'aadhaarPassword', 'optinCommunication'],
}

const company = {
  required: [
    'entityName',
    'dof',
    'entityPan',
    ...authorizedUserAttributes,

    'registrationDocument',
    'entityPanDocument',
    'resolutionDocument',
    ...authorizedUserDocuments,

    'hasGSTN',
    'termsAndConditions',
  ],
  requiredWithGstn: ['gstn', 'address', 'location', 'pincode', 'gstnDocument'],
  optional: ['referralCode', 'aadhaarPassword', 'optinCommunication'],
}

export const registerSubmitOptions = {
  individual: individual,
  nri: nri,
  huf: huf,
  llp: llp,
  company: company,
}

export const documentKeyToDoctypeMap = {
  panDocument: 'DocumentPanCard',
  entityPanDocument: 'DocumentPanCard',
  aadhaarDocument: 'DocumentAadhaarCard',
  phoneBillDocument: 'DocumentPhoneBill',
  nroDocument: 'DocumentNriProof',
  gstnDocument: 'DocumentGstn',
  registrationDocument: 'DocumentCertificateOfIncorporation',
  partnershipDocument: 'DocumentPartnershipDeed',
  resolutionDocument: 'DocumentAnnexureA',
}
